<template>

  <div class="content-box pt-0">
    <div :class="{'active':subMenuShow}"
         class="icone-sub-menu-mobile">
      <i class="fal fa-ellipsis-v"
         @click="subMenuShow=!subMenuShow" />
      <i class="fal fa-times"
         @click="subMenuShow=!subMenuShow" />
      <div class="submenu-caroussel"/>
    </div>
    <sub-menu
      :class="{'active':subMenuShow, 'activeSubMenu':activeSubMenu}"
      class="subTop"
      sub-menu-name="planning"
    />

    <div class="w-100">
      <div class="padded-lg p0">
        <router-view />
      </div>

    </div>
</div></template>
<script>
import SubMenu from '@/components/app/user/partials/navbar/web/subMenu'
import menuJson from '@/components/app/user/partials/navbar/menu.json'
import { mapState } from 'vuex'
export default {
	name: 'operation',
	components: { SubMenu },
	data () {
		return {
			menuJson: menuJson,
			subMenuShow: false,
			activeSubMenu: true
		}
	},
	computed: {
		...mapState('User', ['user', 'permissions'])
	},
	methods: {
		pageChange (i) {
			console.log('current Index', i)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/operation/tour/index.vue